import React from 'react';
import './FloatingDiv.css';
import {themeContext} from '../../Contest';
import {useContext} from 'react';

function FloatingDiv({image,txt1,txt2}) {
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode
  return (
    <div className='floatingDiv'>
      <img src={image} alt="" />
      <span style={{color: darkMode? 'black': 'black'}}>
        {txt1}
        <br />
        {txt2}
      </span>
    </div>
  )
}

export default FloatingDiv
